import "./MGWarning.css"
import MGButton from "../MGButton/MGButton";
export default function MGWarning({
    icon,
    title,
    msg,
    primaryButton,
    secondButton,
    primaryButtonClick,
    secondButtonClick,
    primaryButtonIsEnable = true,
    secondButtonIsEnable = true,
    secondaryText,
    linkText,
    clickLink
}) {
    return (<div className="MGWarning-container">
        <section className="MGWarning-container-text">
            <img src={icon} />
            <span className="MGWarning-container-text-warning title" >{title}</span>
            <span className="MGWarning-container-text-warning msg">{msg}</span>
        </section>
        <section className="MGWarning-container-buttons">
            {primaryButton && (<MGButton label={primaryButton} onClick={primaryButtonClick} type="primary" isEnable={primaryButtonIsEnable} />)}
            {secondButton && (<MGButton label={secondButton} onClick={secondButtonClick} type="secondary" isEnable={secondButtonIsEnable} />)}
        </section>
        <section>
            <span class="MGWarning-secondary-text">{secondaryText}</span>
            <span class="MGWarning-secondary-link" onClick={clickLink}>{linkText}</span>
        </section>
    </div>);
}